import { ThunkDispatch } from 'redux-thunk'
import { createVerifyPhoneNumberFailureAction } from './creators'

export default (status: string) => async (
  dispatch: ThunkDispatch<any, any, any>
) => {
  dispatch(createVerifyPhoneNumberFailureAction(status))
}
